import type { ComponentPropsWithRef, FC } from "react";
import "./RangeInput.css";

interface RangeInputProps extends ComponentPropsWithRef<"input"> {
  label?: string;
}

export const RangeInput: FC<RangeInputProps> = ({ label, id, ...props }) => {
  return (
    <div className="range-input">
      {label && <label htmlFor={id}>{label}</label>}
      <input type="range" id={id} {...props} />
    </div>
  );
};
